module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/operadora/operadora.component.css
// module id = ./src/app/operadora/operadora.component.css
// module chunks = main